// Shared income-projection helpers. Kept plain JS (no JSX) so any file can
// import without JSX overhead. Same math the Dashboard's PayPeriodForecast
// uses via its inline copy — extracting here fixes the Bills-page cushion
// warning that was missing biweekly/weekly paychecks whose anchor date
// fell outside the horizon window (see Feb 2026).

// Project a recurring (or one-time) income row into every occurrence that
// falls inside `[start, end]`. Returns an array of `{...income, expected_date}`
// clones — one per occurrence. The original row is preserved so callers can
// tell base vs projected via `_projected`.
export function projectIncomeOccurrences(inc, start, end) {
  if (inc.status !== "expected") return [];
  const freq = inc.frequency;
  const step = { weekly: 7, biweekly: 14, monthly: 30 }[freq];
  const base = new Date(inc.expected_date + "T00:00:00");
  const endDate = inc.end_date ? new Date(inc.end_date + "T00:00:00") : null;
  if (!step) {
    return (base >= start && base <= end) ? [inc] : [];
  }
  let cur = new Date(base);
  while (cur < start) cur = new Date(cur.getTime() + step * 86400000);
  while (cur > start && new Date(cur.getTime() - step * 86400000) >= start) {
    cur = new Date(cur.getTime() - step * 86400000);
  }
  const out = [];
  while (cur <= end) {
    if (endDate && cur > endDate) break;
    if (cur >= start) {
      const iso = cur.toISOString().slice(0, 10);
      out.push({ ...inc, id: `${inc.id}::${iso}`, expected_date: iso, _projected: iso !== inc.expected_date });
    }
    cur = new Date(cur.getTime() + step * 86400000);
  }
  return out;
}
